export class CompetenceExperienceModel {
  constructor(public competenceDictId: number,
              public yearsOfExperience: number) {
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/ranking/competence-experience.model.ts